<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        از تاریخ</label>
                    <Datepicker simple auto-submit id="from-date" locale="fa" input-format="YYYY-MM-DD" :max="today" v-model="fromDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        تا تاریخ</label>
                    <Datepicker simple auto-submit id="to-date" locale="fa" input-format="YYYY-MM-DD" :max="today" v-model="toDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>شعبه</label>
                        <Vselect v-model="domainDataId" :reduce="item => item.domainDataId" label="fullName" :options="allDomainData">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>طرح</label>
                        <Vselect v-model="themeId" :reduce="item => item.themeId" label="title" :options="themes">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
            </div>
            <div class="row" style="display: flex; justify-content:center ;">
                 <div class="col-md-3" style="margin-top: 29px">
                    <button class="btn btn-primary btn-block" @click="submit" :disabled="!fromDate || !toDate">
                        <i class="si si-magnifier"></i>
                        جستجو
                    </button>
                </div>
                <div class="col-md-3" v-if="rows.length" style="margin-top: 29px">
                    <button class="btn btn-secondary" @click="downloadExcelFile" >دریافت خروجی Excel</button>
                </div>
            </div>
            <div class="alert alert-info mt-4 mb-0" v-if="!rows.length && isSearched">
                <p class="mb-0">اطلاعاتی یافت نشد</p>
            </div>
            <hr v-if="rows.length">
            <table class="table table-hover table-bordered mb-0" v-if="rows.length">
                <thead>
                    <tr>
                        <th>شعبه</th>
                        <th>طرح کارت</th>
                        <th>مرحله</th>
                        <th>تاریخ ثبت سفارش</th>
                        <th>تعداد</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row,index) in rows" :key="index">
                        <td>{{ row.doamain_data_title }}</td>
                        <td>{{ row.them_titlte }}</td>
                        <td>{{ row.flow_step_title }}</td>
                        <td>{{ row.order_date.replace(/\//g,'').slice(0,4) + '/' + row.order_date.replace(/\//g,'').slice(4,6) + '/' + row.order_date.replace(/\//g,'').slice(6,8) }}</td>
                        <td>{{ row.cnt_order }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
                <div class="col-12" style="overflow-x: auto;">
                    <ul class="pagination pagination-circled">
                        <li class="page-item" v-if="currentPage > 1">
                            <a class="page-link" href="#" v-on:click="currentPage--"><i class="icon ion-ios-arrow-forward"></i></a>
                        </li>
                        <li :class="currentPage == page ? 'page-item active' : 'page-item'" v-for="page in pages" :key="page">
                            <a class="page-link" href="#" v-on:click="currentPage = page">{{ page }}</a>
                        </li>
                        <li class="page-item" v-if="pages.length != currentPage">
                            <a class="page-link" href="#" v-on:click="currentPage++"><i class="icon ion-ios-arrow-back"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>
        </div>
    </div>
</template>

<script>
import moment from 'moment-jalaali';
export default {
    name: 'CustomerReport',
    data(){
        return {
            showLoading: true,
            isSearched: false,
            rows: [],
            cardTypes: [],
            fromDate: '',
            today: moment().format('jYYYY-jMM-jDD'),
            toDate: '',
            currentPage: 1,
            domainDataId: '',
            themes: [],
            pages: [1],
            domainData: [],
            allDomainData: [],
            themeId: '',
            options: [],
            perPage: 100,
            count: 0
        }
    },
    watch: {
        currentPage(value){
            this.currentPage = value;
            this.getData();
        }
    },
    methods: {
        baseData(){
            this.$api.get('Cards/Themes').then(({data}) => {
                this.themes = data.result;
            });
            this.$api.post('User/GetDomainData',{domainId: 3}).then(({data}) => {
                if(data.status){
                    this.allDomainData = data.result;
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        getData(excel = false){
            this.showLoading = true;
            const postedData = {
                p_fromdate: this.fromDate.replace(/\//g,''),
                p_todate: this.toDate.replace(/\//g,''),
                p_offset: this.currentPage,
                p_limit: this.perPage,
                p_theme_id: this.themeId,
                p_domain_data: this.domainDataId || 0,
                excel
            };
            this.$api.post('Branches/Report/BodyCard',postedData).then(({data}) => {
                if(data.status && excel)
                    window.open('https://cardapi.sabinarya.com/download/' + data.result.fileName)
                if(data.status && data.result && data.result.p_result){
                    this.rows = data.result.p_result;
                    this.count = data.result.v_count[0].cnt_total;
                    let calcPages = Math.ceil((this.count) / this.perPage);
                    calcPages = calcPages > 1 ? calcPages : 1
                    let pagesArray = [];
                    for(let i = 1;i <= calcPages;i++)
                        pagesArray.push(i);
                    this.pages = pagesArray;
                }
            }).finally(() => {
                this.isSearched = true;
                this.showLoading = false;
            });
        },
        downloadExcelFile(){
            this.getData(true);
        },
        submit(){
            this.getData();
        }
    },
    created(){
        this.baseData();
    }
}
</script>